import React, { FunctionComponent } from 'react';
import { PagePath, SanityImage, SanityNavLink } from '../../../types/common';
import { urlFor } from '../../../utils/imageBuilder';
import PageHeaderLinks from '../../PageHeaderLinks';
import './styles.scss';

type NavItems = SanityNavLink & {
  page: PagePath & {
    title: string;
  };
};

type InternalPageListProps = {
  data: {
    title: string;
    description?: string | null;
    navItems: NavItems[];
    image: SanityImage;
  };
}

const InternalPageList: FunctionComponent<InternalPageListProps> = ({ data }) => {
  return (
    <section className='internal-page-list bark'>
      <div>
        <div>
          <div className='internal-page-list-header'>
            <h2>{data.title}</h2>
            {data.description && (
              <p>{data.description}</p>
            )}
          </div>
          <div className='internal-page-list-container'>
            <PageHeaderLinks
              links={data.navItems.map(link => ({
                ...link,
                typeLink: 'internal',
                name: link.name ? link.name : link.page.title,
              }))}
            />
          </div>
        </div>
        <div className='internal-page-list-image'>
          <img
            src={urlFor(data.image).width(600).quality(90).url()}
            alt={data.image.alt}
          />
        </div>
      </div>
    </section>
  );
}

export default InternalPageList;
